var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentSystemD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 173,
    viewBox: "0 0 105 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3438 55.4063L18.8829 12.0938L6.57819 4.92194V19.1954V109.688V114.398L10.6563 116.719L85.1172 160.031L97.4219 167.203V152.93V62.5079V57.7266L93.3438 55.4063Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2657 62.5079L14.7344 19.1954V109.688L89.2657 152.93V62.5079Z",
    fill: "#DDDDDF",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 71.2969L75.1328 73.6172L29.0781 47.1797L28.9375 45.2812",
    fill: "#A6A6A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 71.2969L75.1328 73.6172L29.0781 47.1797L28.9375 45.2812",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 89.2968L75.1328 91.5468L29.0781 65.1796L28.9375 63.2812",
    fill: "#A6A6A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 89.2968L75.1328 91.5468L29.0781 65.1796L28.9375 63.2812",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 107.297L75.1328 109.547L29.0781 83.1797L28.9375 81.2812",
    fill: "#A6A6A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 107.297L75.1328 109.547L29.0781 83.1797L28.9375 81.2812",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 125.297L75.1328 127.547L29.0781 101.18L28.9375 99.2812",
    fill: "#A6A6A7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0625 125.297L75.1328 127.547L29.0781 101.18L28.9375 99.2812",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentSystemD);
export default __webpack_public_path__ + "static/media/VentSystemD.16fd7dff2d7154f0b5e12e98cdcd51ba.svg";
export { ForwardRef as ReactComponent };